export class BannerFiltersAreaComponent {
    public static SELECTOR: string = ".js-ina-banners__filters";

    private _currentContext: JQuery = $();

    private _classMap = {
        css: {
            hide: "hide"
        }
    };
    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;
    }

    public handleFiltersVisibility(state: boolean): void {
        this._currentContext.toggleClass(this._classMap.css.hide, state);
    }
}
